

// import { useQuery } from 'react-query';
// import axios from 'axios';
// import Papa from 'papaparse';
// import React, { useEffect, useState } from 'react';
// // import Hardware from '../../../public/assets/CSVs/categories.csv';

// // const fetchJsonPlaceholderData = async () => {
// //   const response = await axios.get('https://jsonplaceholder.typicode.com/posts');
// //   
// //   return response.data;
// // };

// //

// const fetchCsvData2 = async () => {
//   try {
//     const response = await axios.get('/assets/CSVs/products.csv');
//     const { data } = response;
//     const parsedData = Papa.parse(data, { header: true }).data;
//     return parsedData;
//   } catch (error) {
//     throw new Error('Failed to fetch and parse CSV data');
//   }
// };

// export function ProductCsvData() {
//   const [productCSVQuery, setProductCSVQuery] = useState([]);
//   const { data, isLoading2, isError2, error2 } = useQuery('ProductCsvData', fetchCsvData2);
//   useEffect(() => {
//     if (!isLoading2 && !isError2) {
//       // Ensure the data is not loading and there are no errors
//       setProductCSVQuery(data);
//     }
//   }, [data, isLoading2, isError2]);

//   return { productCSVQuery, isLoading2, isError2, error2 };
// }




import { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';

const fetchCsvData2 = async () => {
  try {
    const response = await axios.get('/assets/CSVs/products.csv');
    const { data } = response;
    const parsedData = Papa.parse(data, { header: true }).data;
    return parsedData;
  } catch (error) {
    throw new Error('Failed to fetch and parse CSV data');
  }
};

export function ProductCsvData() {
  const [productCSVQuery, setProductCSVQuery] = useState([]);
  const [isLoading2, setIsLoading2] = useState(true);
  const [isError2, setIsError2] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading2(true);
      setIsError2(null);
      try {
        const data = await fetchCsvData2();
        setProductCSVQuery(data);
      } catch (error) {
        setIsError2(error);
      } finally {
        setIsLoading2(false);
      }
    };

    loadData();
  }, []); // Empty dependency array means this useEffect runs once on mount

  return { productCSVQuery, isLoading2, isError2 };
}
